import { render, staticRenderFns } from "./UpgradeRequestModal.vue?vue&type=template&id=1edc951e&scoped=true&"
import script from "./UpgradeRequestModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./UpgradeRequestModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edc951e",
  null
  
)

export default component.exports